import { readonly, ref, type Ref } from 'vue'

import type { ConnectionState } from '../types'

const state = ref<ConnectionState>('connected')
const since = ref<Date>(new Date())
const retryHandler = ref<(() => void) | null>(null)

export function setConnectionState(next: ConnectionState): void {
  if (state.value === next) return
  state.value = next
  since.value = new Date()
}

export function registerRetryHandler(fn: () => void): void {
  retryHandler.value = fn
}

function retry(): void {
  retryHandler.value?.()
}

export function useRealtimeConnectionState(): {
  state: Readonly<Ref<ConnectionState>>
  since: Readonly<Ref<Date>>
  retry: () => void
} {
  return {
    state: readonly(state),
    since: readonly(since),
    retry,
  }
}
